/**
 * Helper class to build OData Urls
 */
export class ODataUrlBuilder {
  /**
   * List of a valid OData parameters
   */
  static combineODataFieldParameters() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    const filtered = params.filter(Boolean);
    const flatten = filtered.reduce((previousValue, currentValue) => previousValue.concat(currentValue), []);
    return [...new Set(flatten)];
  }
  /**
   * Method to build proper parameter string to OData requests based on the given repository configuration and option Object.
   *
   * Checks whether a given parameter is standard OData param or not and based on this information this params get the '$' sign.
   * @param {RepositoryConfiguration} config Represents the current Repository configuration for default select, expand, etc... options
   * @param {ODataParams} options Represents an ODataOptions object. Holds the possible url parameters as properties.
   * @returns {string} String with the url params in the correct format e.g. '$select=DisplayName,Index'&$top=2&metadata=no'.
   */


  static buildUrlParamString(config, options) {
    var _oDataParams$metadata, _oDataParams$inlineco, _oDataParams$expand, _oDataParams$top, _oDataParams$enableau, _oDataParams$enableli;

    const oDataParams = { ...options
    };

    if (config.requiredSelect === 'all' || config.defaultSelect === 'all' || (oDataParams === null || oDataParams === void 0 ? void 0 : oDataParams.select) === 'all') {
      oDataParams.select = undefined;
    } else {
      var _oDataParams$select;

      oDataParams.select = this.combineODataFieldParameters(config.requiredSelect, (_oDataParams$select = oDataParams.select) !== null && _oDataParams$select !== void 0 ? _oDataParams$select : config.defaultSelect);
    }

    oDataParams.metadata = (_oDataParams$metadata = oDataParams.metadata) !== null && _oDataParams$metadata !== void 0 ? _oDataParams$metadata : config.defaultMetadata;
    oDataParams.inlinecount = (_oDataParams$inlineco = oDataParams.inlinecount) !== null && _oDataParams$inlineco !== void 0 ? _oDataParams$inlineco : config.defaultInlineCount;
    oDataParams.expand = (_oDataParams$expand = oDataParams.expand) !== null && _oDataParams$expand !== void 0 ? _oDataParams$expand : config.defaultExpand;
    oDataParams.top = (_oDataParams$top = oDataParams.top) !== null && _oDataParams$top !== void 0 ? _oDataParams$top : config.defaultTop;
    oDataParams.enableautofilters = (_oDataParams$enableau = oDataParams.enableautofilters) !== null && _oDataParams$enableau !== void 0 ? _oDataParams$enableau : config.defaultEnableAutofilters;
    oDataParams.enablelifespanfilter = (_oDataParams$enableli = oDataParams.enablelifespanfilter) !== null && _oDataParams$enableli !== void 0 ? _oDataParams$enableli : config.defaultEnableLifespanfilter;
    const segments = [];

    for (const key in oDataParams) {
      const name = this.ODATA_PARAMS.includes(key) ? `$${key}` : key;
      const plainValue = oDataParams[key];
      let parsedValue = plainValue;

      if (plainValue instanceof Array && plainValue.length) {
        parsedValue = plainValue.map(v => {
          var _v$join, _v$join2;

          return (_v$join = (_v$join2 = v.join) === null || _v$join2 === void 0 ? void 0 : _v$join2.call(v, ' ')) !== null && _v$join !== void 0 ? _v$join : v;
        }).join(',');
      }

      if (name && parsedValue && parsedValue.toString().length) {
        segments.push({
          name,
          value: parsedValue
        });
      }
    }

    return segments.map(s => `${s.name}=${encodeURIComponent(s.value)}`).join('&');
  }

}
ODataUrlBuilder.ODATA_PARAMS = ['select', 'expand', 'orderby', 'top', 'skip', 'filter', 'format', 'inlinecount'];
//# sourceMappingURL=ODataUrlBuilder.js.map